import { FunctionComponent } from 'react';
import { DatePicker } from '../../MaterialUiComponents';
import { Input } from '../../tailwindcomponents';
import { Request } from '../../types/capabilityList';

interface TextFieldsProps {
    request: Request,
    viewMode: boolean,
    setRequest: Function,
}

const DateTextAndJiraLink: FunctionComponent<TextFieldsProps> = ({ request, setRequest, viewMode }) => {
    return (
        <div className="mt-8 flex flex-row flex-wrap justify-center items-center">
            <div className="w-full sm:w-full md:w-1/6 lg:w-1/6">
            <DatePicker
                width={90}
                disabled={viewMode}
                onDateChange={(date: Date) => {
                    setRequest((prevState: Request) => {
                        return {
                            ...prevState,
                            accepted_date: date,
                        };
                    });
                }}
                
                type={"Date"}
                label="Accepted date by Samgöngustofa"
                selected={request.accepted_date ? new Date(request.accepted_date) : new Date()}
            />
            </div>
            <div className="ml-4 w-full sm:w-full md:w-1/3 lg:w-1/3">
                <Input
                    disabled={viewMode}
                    multiline={true}
                    help_text={""}
                    label_text={"Accepted text"}
                    value={request.accepted_text}
                    onTextChange={(text: string) => setRequest((prevState: Request) => ({ ...prevState, accepted_text: text }))}
                    type="text"
                    width={90}
                />
            </div>
            <div className="ml-4 w-full sm:w-full md:w-1/3 lg:w-1/3">
                <Input
                    disabled={viewMode}
                    multiline={true}
                    help_text={""}
                    label_text={"Jira link optional"}
                    value={request.jira_link}
                    onTextChange={(text: string) => setRequest((prevState: Request) => ({ ...prevState, jira_link: text }))}
                    type="text"
                    width={90}
                />
            </div>
        </div>
    )
}
export default DateTextAndJiraLink;

